import { TaskModel, TaskModelMap } from '@/models/responces/task.model'

export const getTasksArray = (tasksMap: TaskModelMap): TaskModel[] => {
  return Object.keys(tasksMap).reduce((res: TaskModel[], v: string) => {
    return res.concat(tasksMap[v])
  }, [])
}